import classNames from 'classnames';
import React from 'react';
import { useFocus } from '../../hooks/use-focus';
import styles from './fieldset.module.scss';
export const Fieldset = ({ id, ariaLabelledBy, ariaDescribedBy, required, className, onBlur, onFocus, ...rest })=>{
    const { handleFocus, handleBlur, containerRef } = useFocus({
        onBlur,
        onFocus
    });
    const labelledBy = [
        ariaLabelledBy,
        ariaDescribedBy
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ React.createElement("fieldset", {
        ref: containerRef,
        id: id,
        "aria-labelledby": labelledBy,
        "aria-required": required,
        className: classNames(styles.fieldset, className),
        onBlur: handleBlur,
        onFocus: handleFocus,
        ...rest
    });
};

//# sourceMappingURL=fieldset.js.map